module.exports = __webpack_public_path__ + "img/bg_ghost_06@3x.8f3ce05f.png";